/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const close_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M5 19 19 5m0 14L5 5"
    />
  </svg>
)
export default close_medium
